<data-container-viewer
	[dataContainerService]='datasetACS'
	[fields]='stepConfig.options.fields' 
	[record]='datasetRS.record.value'
></data-container-viewer>